import React from 'react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
import { getRoadmap } from '../Store/Roadmap';
import { ContextMenu } from '../Models/ContextMenu';
import { BillingContextMenuParam } from '../Models/Requests/BillingContexMenuParam';
import { AiOutlineClose } from "react-icons/ai";
import PopupContextMenu from './PopupContext';
import { PopupContextParam } from '../Models/Requests/PopupContextParam';
import SharingContext from "../Modals/SharingContext";
import { SharingContextParam } from "../Models/Requests/SharingContextParam";
import { openSocket } from '../Helpers/openSocket';
import { getSettings } from '../Store/Settings';
import { getStripe, cancelSubscription, setStripeStatus } from '../Store/Stripe';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { SubscriptionContextMenuParam } from '../Models/Requests/SubscriptionContexMenuParam';
import SubscriptionContextMenu from './SubscriptionContextMenu';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../Helpers/Stripe';
import { StripePlan } from '../Models/Requests/StripePlan';
import { addDays, parseISO, format } from 'date-fns';
import { joinWaitlist } from '../Store/Utility';
import { isValidEmail } from '../Helpers/isValidEmail';
import { getUser } from '../Store/Auth';
import { useIsMobile } from '../Core/hooks';

interface Props {
    params: BillingContextMenuParam | undefined;    
}

function BillingContextMenu(props: Props) {

    const dispatch = useAppDispatch();
    const userState = useAppSelector(getUser);
    const roadmapState = useAppSelector(getRoadmap);
    const settingsState = useAppSelector(getSettings);
    const stripeState = useAppSelector(getStripe);
    const [popupParams, setPopupParams] = useState<PopupContextParam>();
    const [billingContextMenu, setBillingContextMenu] = useState<ContextMenu>();
    const [subscriptionContextMenuParams, setSubscriptionContextMenuParams] = useState<SubscriptionContextMenuParam>();
    const [canceling, setCanceling] = useState(false);
    const [teamsSuccess, setTeamsSuccess] = useState<boolean>(false);
    const isMobile = useIsMobile();

    /*useEffect(() => {
        setSubscriptionContextMenuParams(undefined);
    },[])*/

    useEffect(() => {
        if (stripeState.status === "subscriptionCanceled") {
            dispatch(setStripeStatus("idle"));
            setCanceling(false);
        }
    }, [stripeState.status]);

    useEffect(() => {
        if (props.params) {
            let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
            if ( (billingContextMenu && billingContextMenu._id !== props.params.id) || !billingContextMenu) {
                if (props.params.event) {
                    let menuWidth = window.outerWidth * .8;
                    let menuHeight = window.outerHeight * .74;
                    let menuXStart = window.outerWidth * .1;
                    let menuYStart = 30;
                    /*
                    let menuXStart = props.params.event.clientX - 10;
                    let menuYStart = props.params.event.clientY + 20
                    
                    if (menuXStart + menuWidth > window.outerWidth) {
                        menuXStart = window.outerWidth - menuWidth - 80;
                    }*/
                    contextMenu._id = props.params.id;
                    contextMenu.x = menuXStart;
                    contextMenu.y = menuYStart;
                    contextMenu.width = menuWidth;
                    contextMenu.height = menuHeight;
                }
            }
            setBillingContextMenu(contextMenu);
        }
    }, [props.params]);

    const closeContextMenu = (e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        closeMenu();
    }

    const closeMenu = () => {
        let contextMenu = { _id: "", x: 0, y: 0, width: 0, height: 0 };
        setBillingContextMenu(contextMenu);
    }
    
    const handleBilling = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>, priceId: string) => {
        e.preventDefault();
        //console.log(priceId);
        setSubscriptionContextMenuParams({ id: priceId, event: e, closeHandler: closeMenu }); 
    }

    const handleCancelBilling = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if (stripeState.mostRecentPayment) {
            setCanceling(true);
            dispatch(cancelSubscription({ subscriptionId: stripeState.mostRecentPayment.subscriptionId }));
        }
    }

    const handleChangeBilling = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>, priceId: string) => {
        e.preventDefault();
        //console.log(priceId);
        setSubscriptionContextMenuParams({ id: priceId, event: e, closeHandler: closeMenu, changingSubscription: true }); 
    }

    const handleJoinTeamsWaitlist = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => {
        
        e.preventDefault();

        if (e.type === "keydown" ) {
            let keypress = e as React.KeyboardEvent;
            if (keypress.key !== 'Enter') {
                return;
            }            
        }
        
        setTeamsSuccess(true);
        setTimeout(() => setTeamsSuccess(false), 2000);
        dispatch(joinWaitlist({
            firstName: userState.firstName,
            lastName: userState.lastName,
            email: userState.email,
            marketingSource: "Teams query from existing user with package: " + stripeState.mostRecentPayment?.stripePlanId
        }));
    }
    /*
    const sContextMenu: React.CSSProperties = {
        top: (billingContextMenu) ? billingContextMenu.y : 0,
        left: (billingContextMenu) ? billingContextMenu.x : 0,
        width: (billingContextMenu) ? billingContextMenu.width : 0,
        height: "575px"
    }
    */
    const sContextMenu: React.CSSProperties = {
        top: billingContextMenu && !isMobile ? billingContextMenu.y : 0,
        left: billingContextMenu && !isMobile ? billingContextMenu.x : 0,
        width: isMobile 
            ? "100vw" 
            : billingContextMenu 
                ? billingContextMenu.width 
                : 300,
        height: isMobile ? "100vh" : "575px",
        ...(isMobile && { overflowY: "auto" })
    };

    let plan1 = stripeState.plans.find(p => p.sort === 0);
    let plan2 = stripeState.plans.find(p => p.sort === 1);
    let plan3 = stripeState.plans.find(p => p.sort === 2);
    //let plan3 = stripeState.plans.find(p => p.sort === 3);

    let currentPlan: StripePlan | undefined = undefined;
    let recentPayment = stripeState.mostRecentPayment;
    let formattedSubscriptionRenewal = "";
    let today = new Date();
    
    if (recentPayment) {
        currentPlan = stripeState.plans.find(p => p._id === recentPayment!.stripePlanId && recentPayment!.active);
        const subscriptionRenewal = addDays(new Date(recentPayment.payment), 30);
        // Format: "MMM do" => "Apr 13th", "Feb 2nd", etc.
        //console.log(subscriptionRenewal);
        formattedSubscriptionRenewal = format(subscriptionRenewal, 'MMM do');
    }

    return (
        <>
            {billingContextMenu && billingContextMenu._id !== "" &&
                <div onClick={e => closeMenu()} className="windowContainer">
                    <div className="contextMenu" style={sContextMenu} onClick={e => { e.preventDefault(); e.stopPropagation(); }}>
                        <div style={{ position: "relative" }}>
                            <div className="divClose">
                                <Link to="" onClick={(e) => closeContextMenu(e)}>
                                    <AiOutlineClose color="#555" size="13" />
                                </Link>
                            </div>
                        </div>
                        <div style={{ fontSize: "24pt", fontWeight: "400", textAlign: "center", padding: "0px 30px" }}>
                            {currentPlan ? "Cancel or change your plan" : "Select your plan" }
                        </div>
                        {!currentPlan ?
                            <div className="billingBlurb1" style={{ paddingTop: "10px", margin: "0px auto", fontSize: "11pt", fontWeight: "350", textAlign: "center" }}>
                                Choose one of three plans below to continue using herdr and avoid disruptions to your work.
                                {recentPayment && !recentPayment.active && today < addDays(new Date(recentPayment.payment), 30) && 
                                    <span style={{ fontWeight: "bold", color: "red" }}>
                                        {"You're plan has been cancelled with access ending on " + formattedSubscriptionRenewal}
                                    </span>
                                }
                            </div>
                        :
                            <div className="billingBlurb2" style={{ paddingTop: "10px", margin: "0px auto", fontSize: "11pt", fontWeight: "350", textAlign: "center" }}>
                                <b>Canceling keeps access until {formattedSubscriptionRenewal}</b>. 
                                Upgrades or downgrades charge your card immediately at the new rate.
                            </div>              
                        }
                        {plan1 && plan2 && plan3 &&
                            <div className="pricingBillingParentBox">
                                <div className="pricingBillingBox"> 
                                    <div style={{ width: "90%", margin: "0px auto" }}>
                                        <div className="pricingBillingTitle">
                                            {plan1!.name}
                                        </div>
                                        <div style={{ textAlign: "left", marginLeft: "10px", marginTop: "5px", fontSize: "11pt", color: "#495866", fontWeight: "400" }}>
                                            {plan1!.description}
                                        </div>
                                        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                            <div style={{ textAlign: "left", marginLeft: "10px", fontSize: "24pt", fontWeight: "bold" }}>
                                                ${plan1!.price}
                                            </div>
                                            <div style={{ fontSize: ".8em", textAlign: "left", marginLeft: "10px", color: "#495866", fontWeight: "400" }}>
                                                {plan1!.billingCycle === 1 && "Per user, per month, billed monthly" }
                                            </div>
                                        </div>
                                        {!currentPlan ?
                                            <button className="blueButton" onClick={(e) => handleBilling(e, plan1!.priceId)} onKeyDown={(e) => handleBilling(e, plan1!.priceId)}>
                                                Select {plan1!.name.charAt(0).toUpperCase() + plan1!.name.slice(1).toLowerCase()}
                                            </button> 
                                        :
                                            <>
                                            {currentPlan._id === plan1!._id ?
                                                <button className="orangeButton" 
                                                onClick={(e) => handleCancelBilling(e)} onKeyDown={(e) => handleCancelBilling(e)}>
                                                    {canceling ? 'Canceling...' : 'Cancel'}
                                                </button> 
                                            :
                                                <button className="blueButton" onClick={(e) => handleChangeBilling(e, plan1!.priceId)} onKeyDown={(e) => handleChangeBilling(e, plan1!.priceId)}>
                                                    Select
                                                </button> 
                                            }  
                                            </>
                                        }
                                        <hr className="billingDivider" />
                                        <div style={{ textAlign: "left" }}>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan1!.features[0]}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan1!.features[1]} 
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan1!.features[2]}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan1!.features[3]}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="pricingBillingBox"> 
                                    <div style={{ width: "90%", margin: "0px auto" }}>
                                        <div className="pricingBillingTitle">
                                            {plan2!.name}
                                        </div>
                                        <div style={{ textAlign: "left", marginLeft: "10px", marginTop: "5px", fontSize: "11pt", color: "#495866", fontWeight: "400" }}>
                                            {plan2!.description}
                                        </div>
                                        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                            <div style={{ textAlign: "left", marginLeft: "10px", fontSize: "24pt", fontWeight: "bold" }}>
                                                ${plan2!.price}
                                            </div>
                                            <div style={{ fontSize: ".8em", textAlign: "left", marginLeft: "10px", color: "#495866", fontWeight: "400" }}>
                                                {plan2!.billingCycle === 1 && "Per user, per month, billed monthly" }
                                            </div>
                                        </div>
                                        {!currentPlan ?
                                            <button className="blueButton" onClick={(e) => handleBilling(e, plan2!.priceId)} onKeyDown={(e) => handleBilling(e, plan2!.priceId)}>
                                                Select {plan2!.name.charAt(0).toUpperCase() + plan2!.name.slice(1).toLowerCase()}
                                            </button> 
                                        :
                                            <>
                                            {currentPlan._id === plan2!._id ?
                                                <button className="orangeButton" onClick={(e) => handleCancelBilling(e)} onKeyDown={(e) => handleCancelBilling(e)}>
                                                    {canceling ? 'Canceling...' : 'Cancel'}
                                                </button> 
                                            :
                                                <button className="blueButton" onClick={(e) => handleChangeBilling(e, plan2!.priceId)} onKeyDown={(e) => handleChangeBilling(e, plan2!.priceId)}>
                                                    Select
                                                </button> 
                                            }  
                                            </>
                                        }
                                        <hr className="billingDivider" />
                                        <div style={{ textAlign: "left" }}>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan2!.features[0]}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan2!.features[1]}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan2!.features[2]}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan2!.features[3]}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="pricingBillingBox"> 
                                    <div style={{ width: "90%", margin: "0px auto" }}>
                                        <div className="pricingBillingTitle">
                                            {plan3!.name}
                                        </div>
                                        <div style={{ textAlign: "left", marginLeft: "10px", marginTop: "5px", fontSize: "11pt", color: "#495866", fontWeight: "400" }}>
                                            {plan3!.description}
                                        </div>
                                        <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                            <div style={{ textAlign: "left", marginLeft: "10px", fontSize: "24pt", fontWeight: "bold" }}>
                                                ${plan3!.price}
                                            </div>
                                            <div style={{ fontSize: ".8em", textAlign: "left", marginLeft: "10px", color: "#495866", fontWeight: "400" }}>
                                                {plan3!.billingCycle === 1 && "Per user, per month, billed monthly" }
                                            </div>
                                        </div>

                                        {teamsSuccess &&
                                            <div className="success" style={{ marginTop: "5px", marginBottom: "0px" }}>
                                                You're on the list!
                                            </div>
                                        }
                                                                                
                                        <button className="blueButton" onClick={(e) => handleJoinTeamsWaitlist(e)} 
                                            onKeyDown={(e) => handleJoinTeamsWaitlist(e)}>
                                            Join the Waitlist
                                        </button> 
                                        {/*
                                        {!currentPlan ?
                                            <button className="blueButton" onClick={(e) => handleBilling(e, plan3!.priceId)} onKeyDown={(e) => handleBilling(e, plan3!.priceId)}>
                                                Select {plan3!.name.charAt(0).toUpperCase() + plan3!.name.slice(1).toLowerCase()}
                                            </button> 
                                        :
                                            <>
                                            {currentPlan._id === plan3!._id ?
                                                <button className="orangeButton" onClick={(e) => handleCancelBilling(e)} onKeyDown={(e) => handleCancelBilling(e)}>
                                                    {canceling ? 'Canceling...' : 'Cancel'}
                                                </button> 
                                            :
                                                <button className="blueButton" onClick={(e) => handleChangeBilling(e, plan3!.priceId)} onKeyDown={(e) => handleChangeBilling(e, plan3!.priceId)}>
                                                    Select
                                                </button> 
                                            }  
                                            </>
                                        }
                                        */}
                                        <hr className="billingDivider" />
                                        <div style={{ textAlign: "left" }}>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                    {plan3!.features[0]}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                {plan3!.features[1]}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                {plan3!.features[2]}
                                                </div>
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <div style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <IoMdCheckmarkCircleOutline size={20} />
                                                </div>
                                                <div style={{ position: "relative", top: "2px", fontSize: "11pt", display: "inline-block" }}>
                                                {plan3!.features[3]}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
            <Elements stripe={stripePromise}>
                <SubscriptionContextMenu params={subscriptionContextMenuParams} />
            </Elements>
        </>
    );
}

export default BillingContextMenu;